import { SIDENAV_TOKENS } from '@app/components/layout/sidenav/sidenav-tokens';
import { Box } from '@mui/material';
import { SidenavAccountRow } from './account/SidenavAccountRow';
import { SidenavIdentityRow } from './identity/SidenavIdentityRow';

/**
 * Sidenav top chrome: brand + tenant/change-user + notifications, then account row.
 */
export function SidenavHeader() {
  const tokens = SIDENAV_TOKENS;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.headerGap,
        pb: tokens.headerPaddingBottom,
      }}
    >
      <SidenavIdentityRow />
      <SidenavAccountRow />
    </Box>
  );
}
